import { render, staticRenderFns } from "./ParamEndereco.vue?vue&type=template&id=05317c70"
import script from "./ParamEndereco.vue?vue&type=script&lang=js"
export * from "./ParamEndereco.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports